import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { SENTRY_IGNORE_ERRORS, sentryBeforeSend } from '@agilox/sentry';

import { environment } from './environments/environment';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
	enableProdMode();

	Sentry.init({
		dsn: 'https://dd59767d97f3bfa95569442b812ef763@o919676.ingest.sentry.io/4506554161954816',
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				networkDetailAllowUrls: ['https://my.agilox.net'],
				networkCaptureBodies: true,
			}),
		],
		tracePropagationTargets: ['https://my.agilox.net'], // TODO: change to production url
		ignoreErrors: SENTRY_IGNORE_ERRORS,
		beforeSend: sentryBeforeSend,
		// Set tracesSampleRate to 1.0 to capture 100%
		// of transactions for performance monitoring.
		tracesSampleRate: 0.5,
		/**
		 * This causes the envelope size to be too big in some cases
		 * e.g. fleet-overview, replay
		 * Should only be uncommented when needed!
		 * https://develop.sentry.dev/sdk/envelopes/#size-limits
		 * /
		 beforeBreadcrumb: (breadcrumb: Sentry.Breadcrumb, hint: Sentry.BreadcrumbHint) => {
		 if (breadcrumb.category === 'xhr') {
		 breadcrumb.data = (hint['xhr'] as XMLHttpRequest).response;
		 const data = {
		 requestBody: hint['xhr'].__sentry_xhr_v3__.body,
		 response: hint['xhr'].response,
		 responseUrl: hint['xhr'].responseURL,
		 };
		 return { ...breadcrumb, data };
		 }
		 return breadcrumb;
		 },
		 **/
	});
}

bootstrapApplication(AppComponent, {
	...appConfig,
	providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
